module.exports = __webpack_public_path__ + "img/female-bot.8de942ad.png";